export default __webpack_public_path__ + "static/media/bg_team.05157391.png";